import { css } from '@emotion/react';
import { Outlet, useMatchRoute } from '@tanstack/react-location';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { reviewServicesList } from '../../constants';
import { NoReviewsEmptyState } from './no-reviews-empty-state';
import { ReviewsEmptyState } from './reviews-empty-state';

const EmptyStateReviews = ({ noReviews }: ReviewViewsProps) => {
  const { t } = useTranslation('reviews');

  return (
    <div
      css={css`
        left: 0;
        display: flex;
        align-items: center;
        padding: ${theme.spacing(5, 5)};
        flex-direction: column;
        height: 100%;
        justify-content: center;
        gap: ${theme.spacing(1)};
      `}
    >
      {noReviews ? (
        <>
          <NoReviewsEmptyState />
          <Text color='light' textAlign='center'>
            {t("There's nothing that can stop you from becoming popular.")}
          </Text>
        </>
      ) : (
        <>
          <ReviewsEmptyState />
          <Text color='light' textAlign='center'>
            {t('Are your ears ringing? People are talking about you.')}
          </Text>
          <Text size='medium' color='light' textAlign='center'>
            {t('Click a review on the left to read and reply.')}
          </Text>
        </>
      )}
    </div>
  );
};

type ReviewViewsProps = {
  noReviews?: boolean;
};

export const ReviewView = ({ noReviews }: ReviewViewsProps) => {
  const matchRoute = useMatchRoute();
  const match = reviewServicesList.some((site) => matchRoute({ to: `/reviews/${site}/:reviewId` }));

  return match ? <Outlet /> : <EmptyStateReviews noReviews={noReviews} />;
};
